import Markup from "../../../../markup";
import Tooltip from "../../../Global/Tooltip";
import React, {useContext} from "react";
import BuilderContext from "../../../../builder/hooks/context";
import {useMediaQuery} from "react-responsive";
import {device} from "../../../../const/device";

function SurfaceNotice (props){
    const { builder } = useContext(BuilderContext);
    const isTablet = useMediaQuery({ query: `(${device.tablet})` });

    return(
        <div>
            <Markup.Screen.Name.SpecItemText themeColor={builder.membersData.colorTheme}>{props.text}{ props.switch ? <Tooltip Icon={Markup.Global.Link.LinkHelpIcon} width={isTablet ? 320 : 366} offset={ isTablet ? -190 : -100} bottom>
                <Markup.Screen.Color.HelpTextContainer>
                    {props.textContent}
                </Markup.Screen.Color.HelpTextContainer>
            </Tooltip> : ''}
            </Markup.Screen.Name.SpecItemText>
        </div>
    );
}

export default SurfaceNotice;